import React, { useState } from 'react';

export default function Tooltip({ children, title, body }) {
  const [visible, setVisible] = useState(false);

  const wrapperStyle = {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
  };

  const tooltipBoxStyle = {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'normal',
    padding: '14px 18px',
    background: '#fff',
    color: '#212529',
    fontSize: '14px',
    borderRadius: '8px',
    zIndex: 100,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.12)',
    textAlign: 'left',
    minWidth: '250px',
    maxWidth: '320px',
    border: 'none',
    display: 'flex',
    width: '309px',
    padding: '10px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    border: '1px solid var(--Background-Gray, #E9ECEF)',
    background: 'var(--Gray-100, #F8F9FA)',
  };

  const arrowStyle = {
    position: 'absolute',
    top: '-6px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '0',
    height: '0',
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    borderBottom: '7px solid #fff',
    filter: 'drop-shadow(0 -2px 8px rgba(0,0,0,0.06))'
  };

  const titleStyle = {
    fontWeight: 600,
    marginBottom: '6px',
    fontSize: '15px',
    marginTop: 0,
  };

  const bodyStyle = {
    margin: 0,
    fontSize: '13px',
    color: '#212529',
    lineHeight: 1.54,
  };

  return (
    <span
      style={wrapperStyle}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div style={tooltipBoxStyle}>
          <div style={arrowStyle}></div>
          {title && <p style={titleStyle}>{title}</p>}
          {body && <p style={bodyStyle}>{body}</p>}
        </div>
      )}
    </span>
  );
}